/* eslint-disable @typescript-eslint/consistent-type-imports */
import React from 'react';
import { useIntl } from 'react-intl-next';

import type { PublicPluginAPI } from '@atlaskit/editor-common/types';
import type { QuickInsertPlugin } from '@atlaskit/editor-plugin-quick-insert';
import type { ExtensionConfiguration } from '@atlaskit/editor-plugin-selection-extension';

import { useHandleCreateSnippet } from '../hooks/useHandleCreateSnippet.ts';
import { useIsSnippetCreateEnabled } from '../hooks/useIsSnippetCreateEnabled.ts';

import { buildSnippetExtension } from './buildSnippetExtension.ts';

export type UseSnippetExtensionProps = {
	contentId: string;
	spaceId: string;
	spaceKey: string;
	editorAPIRef?: React.RefObject<PublicPluginAPI<[QuickInsertPlugin]> | null | undefined>;
};

/**
 * Returns the snippet extension list for the selection extension (create block template).
 * Pass editorAPIRef from the caller (e.g. a ref holding fullPageEditorPresetAPI from useFullPageEditorApi).
 */
export const useSnippetExtension = ({
	contentId,
	spaceId,
	spaceKey,
	editorAPIRef,
}: UseSnippetExtensionProps): ExtensionConfiguration[] => {
	const { formatMessage } = useIntl();
	const isCreateEnabled = useIsSnippetCreateEnabled();
	const handleCreateSnippet = useHandleCreateSnippet({
		contentId,
		spaceId,
		spaceKey,
		editorAPIRef,
	});

	if (!isCreateEnabled) {
		return [];
	}

	return buildSnippetExtension({
		formatMessage,
		onCreateSnippet: handleCreateSnippet,
	});
};
